import React from "react";
import { 
  FaFacebook, 
  FaTwitter, 
  FaWhatsapp, 
  FaEnvelope, 
  FaLink,
  FaLinkedin
} from "react-icons/fa";

const ShareModal = ({ onClose, shareUrl, title }) => {

  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);

  const networks = [
    {
      name: "Facebook",
      icon: <FaFacebook />,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      name: "LinkedIn",
      icon: <FaLinkedin />,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    },
    {
      name: "Twitter",
      icon: <FaTwitter />,
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    },
    {
      name: "WhatsApp",
      icon: <FaWhatsapp />,
      url: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`,
    },
    {
      name: "Email",
      icon: <FaEnvelope />,
      url: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
    },
  ];

  const handleClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer,width=600,height=400");
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    alert("Lien copié dans le presse-papier !");
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          width: "300px",
          textAlign: "center",
          boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
        }}
      >
        <h2 style={{ marginBottom: "15px" }}>Partager INTERESEAUX</h2>

        <div style={{ display: "flex", justifyContent: "space-around", marginBottom: "15px" }}>
          {networks.map((network) => (
            <button
              key={network.name}
              onClick={() => handleClick(network.url)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "24px",
                color: "#333",
              }}
              title={`Partager sur ${network.name}`}
            >
              {network.icon}
            </button>
          ))}
        </div>

        <div style={{ marginBottom: "15px" }}>
          <input
            type="text"
            readOnly
            value={shareUrl}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              marginBottom: "5px",
            }}
          />
          <button
            onClick={handleCopy}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#4CAF50",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            <FaLink style={{ marginRight: "6px" }} /> Copier le lien
          </button>
        </div>

        <button
          onClick={onClose}
          style={{
            padding: "6px 12px",
            borderRadius: "6px",
            border: "none",
            backgroundColor: "#f44336",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Fermer
        </button>
      </div>
    </div>
  );
};

export default ShareModal;
